export default __webpack_public_path__ + "static/media/eye.220073fc.svg";